import providerToAmountFilter from './provider-to-amount';
import providerNameFilter from './provider-name';

export default angular
    .module('paysera.currencyExchange.filters', [])
    .filter('providerToAmount', providerToAmountFilter)
    .filter('providerName', providerNameFilter)
    .name
;
